export default __webpack_public_path__ + "static/media/EN_02.512d9018.svg";